type IconProps = {
	width?: number;
	height?: number;
	color?: string;
}

export const FreightIssuesIcon = (props:IconProps) => {
	const {
		width = 20,
		height = 20,
		color = 'var(--brand-orange-default)'
	} = props;
	return (
		<svg role={'img'} xmlns={'http://www.w3.org/2000/svg'} width={width} height={height} viewBox={'0 -960 960 960'} fill={color}>
			<path d="M480-800 243-663l237 137 237-137-237-137ZM120-321v-318q0-22 10.5-40t29.5-29l280-161q10-5 19.5-8t20.5-3q11 0 21 3t19 8l280 161q19 11 29.5 29t10.5 40v159h-80v-116L479-434 200-596v274l240 139v92L160-252q-19-11-29.5-29T120-321ZM720-80q8 0 14-6t6-14q0-8-6-14t-14-6q-8 0-14 6t-6 14q0 8 6 14t14 6Zm-20-80h40v-160h-40v160ZM720 0q-83 0-141.5-58.5T520-200q0-83 58.5-141.5T720-400q83 0 141.5 58.5T920-200q0 83-58.5 141.5T720 0ZM480-491Z"/>
		</svg>
	);
};
